import src from "IMAGE";
export default { src, width: 1203, height: 532, blurWidth: 0, blurHeight: 0};
